import { useEffect } from "react";
import Slider from "react-slick";
import AOS from "aos";
import "aos/dist/aos.css";

const testimonials = [
  {
    name: "Ullas U",
    role: "Parent",
    testimonial: "SVN Convent and English High School has provided my child with an excellent education, both academically and in extracurriculars. I’m very impressed with the caring and professional staff.",
  },
  {
    name: "Srinivas Shetty",
    role: "Student",
    testimonial: "Being a part of this school has helped me grow both intellectually and personally. The teachers are so supportive, and I love the emphasis on all-round development.",
  },
  {
    name: "Virat Kohli",
    role: "Alumni",
    testimonial: "The values and knowledge I gained from SVN Convent have shaped who I am today. The school prepared me well for the challenges ahead in my professional life.",
  },
];

export default function Testimonials() {
  const settings = {
    dots: true, // Adds dots for navigation
    infinite: true, // Infinite scrolling
    speed: 500, // Transition speed
    slidesToShow: 1, // Show one slide at a time
    slidesToScroll: 1, // Scroll one slide at a time
    autoplay: true, // Auto slide
    autoplaySpeed: 5000, // Slide change every 5 seconds
    draggable: true, // Enable dragging to slide
  };

       useEffect(() => {
              AOS.init({ duration: 1000 });
          }, []);

  return (
    <section className="mt-12 container mx-auto px-6 "  data-aos="fade-up">
      <div className="text-center mb-8">
        <h2 className="text-xl md:text-2xl font-bold text-green-600">TESTIMONIALS</h2>
      </div>
      <div className="relative">
        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="p-6 text-center bg-gray-100 shadow-lg rounded-lg cursor-grab">
              <p className="text-lg italic mb-4">"{testimonial.testimonial}"</p>
              <h3 className="font-semibold text-lg">{testimonial.name}</h3>
              <p className="text-sm text-gray-500">{testimonial.role}</p>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
